
export const PRODUCTS = [
    { name: "Gameserver", link: "#" },
    { name: "Voiceserveur", link: "#" },
    { name: "TS3Musicbot", link: "#" },
    { name: "Minecraft Guide", link: "#" },
    { name: "Domains", link: "#" },
    { name: "Prices", link: "#" },
];

export const COMPANY = [
    { name: "About us", link: "#" },
    { name: "Careers", link: "#" },
    { name: "Status", link: "#" },
    { name: "Terms and Conditions", link: "#" },
    { name: "Data privacy", link: "#" },
    { name: "Legal notice", link: "#" },
    { name: "Manage cookie preferences", link: "#" },
  ];
  export const TECHNOLOGY = [
    { name: "Our Datacenters", link: "#" },
    { name: "Nitardo for Business", link: "#" },
    { name: "Third-party licenses", link: "#" },
  ];
  
  export const SUPPORT = [
    { name: "Board", link: "#" },
    { name: "Ticket & Chat", link: "#" },
    { name: "Wiki / Knowledgebase", link: "#" },
    { name: "Information for parents", link: "#" },
  ];
  
  export const Icons = [
    { name: "logo-facebook", link: "#" },
    { name: "logo-twitter", link: "#" },
    { name: "logo-github", link: "#" },
    { name: "logo-linkedin", link: "#" },
    { name: "logo-instagram", link: "#" },
  ];